import { ReactNode, useEffect } from 'react';

import { APP_BASE_URL } from '@/constants';

export function AppRedirectHandler({ children }: { children: ReactNode }) {
  const { origin, pathname, search, hash } = location;

  // app router located at host/<APP_BASE_URL>, so we need to redirect to it when location.pathname doesn't include it
  // for example when host/ -> redirecting to host/<APP_BASE_URL>/ to ensure proper routing
  // we should locate app router under /<APP_BASE_URL> for correct sidebar navigation work
  useEffect(() => {
    if (!location.pathname.includes(APP_BASE_URL)) {
      location.replace(`${origin}${APP_BASE_URL}${pathname}${search}${hash}`);
    }
  }, []);

  return <>{children}</>;
}
